import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ApiService } from '../services/apiService';
import { StatusPageLayout } from '../components/layout/StatusPageLayout';
import { CardState } from '../types/cardTypes';

const kycCompleteRoute = (id: string) =>
  `/redirect-to-activation?cardId=${encodeURIComponent(id)}`;

const KycInProcess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const cardId = searchParams.get('cardId') || '';
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!cardId.trim()) {
      setError('Card ID is required.');
      return;
    }

    let redirected = false;
    void (async () => {
      try {
        const card = await ApiService.getCardByCardId(cardId);
        if (card?.state !== CardState.KYCPENDING) {
          redirected = true;
          const status = await ApiService.getSumsubKycStatus();
          if (status.success && status.data?.readyForActivation) {
            navigate(kycCompleteRoute(cardId));
          } else {
            navigate(`/kyc-verification?cardId=${encodeURIComponent(cardId)}`);
          }
        }
      } catch {
        // Ignore and continue polling.
      }
    })();

    let stopped = false;
    const id = window.setInterval(() => {
      if (redirected) return;
      void (async () => {
        try {
          const status = await ApiService.getSumsubKycStatus();
          if (stopped || !status.success || !status.data) return;

          if (status.data.readyForActivation || status.data.sumsubKycStatus === 'rejected') {
            window.clearInterval(id);
            if (status.data.readyForActivation) {
              navigate(kycCompleteRoute(cardId));
            } else {
              navigate(`/card/${encodeURIComponent(cardId)}`);
            }
          }
        } catch (e) {
          console.warn('KYC in process poll failed', e);
        }
      })();
    }, 4000);

    return () => {
      stopped = true;
      window.clearInterval(id);
    };
  }, [cardId, navigate]);

  return (
    <StatusPageLayout
      variant="loading"
      title="KYC in process"
      body={
        error ||
        "Your identity verification is in progress. We'll update your card automatically when we receive a final decision."
      }
    />
  );
};

export default KycInProcess;
